var _path, _path2, _circle, _circle2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.941614 21.2607C1.24965 21.2607 3.45878 21.2607 3.76502 21.2607V25.4344H0.941614V21.2607ZM17.2456 22.3119L11.1649 23.7641C10.8726 23.8339 10.5725 23.8693 10.2729 23.8693H8.85324C8.23091 23.8693 7.61945 23.9923 7.03585 24.2349L4.70616 25.2033V21.0054C4.83693 20.903 4.97824 20.8038 5.12464 20.7299L9.93173 18.3108C10.3179 18.1165 10.7364 18.5085 10.6267 18.9625C10.592 19.1058 10.5081 19.2278 10.3926 19.3022L8.88773 20.27C8.70369 20.3883 8.61419 20.6288 8.66938 20.8566C8.72458 21.0844 8.91079 21.2428 9.12353 21.243C17.6754 21.2492 17.051 21.2302 17.199 21.2549C17.4444 21.3131 17.594 21.5424 17.594 21.7897C17.5941 22.029 17.4514 22.2419 17.2456 22.3119ZM21.1452 19.6406C20.9848 19.9962 20.6623 20.2172 20.3036 20.2172C12.391 20.1853 18.7848 20.2032 10.8715 20.2004C11.5586 19.7524 11.791 18.7702 11.3853 18.0073C11.0098 17.2994 10.2178 17.0214 9.5429 17.3605C4.3522 19.9739 4.61318 19.8237 4.32255 20.0331C4.24006 20.0925 4.16096 20.154 4.08219 20.2172H3.74056C3.38542 20.2172 3.06435 19.9994 2.90266 19.649L1.2401 16.0434H22.7675L21.1452 19.6406Z",
    fill: "#AAAAAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9552 14.0007C23.0048 14.5508 22.555 15 22.0027 15C20.2648 15 16.4395 15 12 15C7.56049 15 3.73524 15 1.99728 15C1.445 15 0.995245 14.5508 1.04478 14.0007C1.54965 8.39389 6.2617 4 12 4C17.7383 4 22.4503 8.39389 22.9552 14.0007Z",
    fill: "#AAAAAA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 2,
    r: 2,
    fill: "#AAAAAA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 14,
    r: 5.5,
    fill: "#AAAAAA",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 14.3125L20.0625 15.875L23.1875 12.75",
    stroke: "white",
    strokeWidth: 0.78125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServing);
export default __webpack_public_path__ + "static/media/serving.d1701ef59b90280a6442d74c0eb8116b.svg";
export { ForwardRef as ReactComponent };